import { memo } from 'react'
import { AudienceIcon } from '@/components/mediaBuying/adCampaign/AudienceIcon'
import { RadioGroupItem } from '@/components/ui/radio-group'
import CreativeThumbnail from './CreativeThumbnail'
import { Label } from '@/components/ui/label'
import { FUNNEL_STAGES } from '@/utils/ad-campaign-constants'

const CountBadge = ({ stage, count }) => {
    const { recommendedMinCreatives, recommendedMaxCreatives } = FUNNEL_STAGES[stage.id]
    let color = ''

    if (count >= recommendedMinCreatives && count <= recommendedMaxCreatives) {
        color = 'tw:bg-green-500'
    } else if (count === 0) {
        color = 'tw:bg-red-500'
    } else {
        color = 'tw:bg-yellow-500'
    }

    return (
        <div className={`${color} tw:rounded-full tw:px-2 tw:py-1 tw:text-xs tw:font-medium tw:min-w-6 tw:text-center`}>
            {count}
        </div>
    )
}

const AudienceStageItem = memo(
    ({ audience, stage, stageAudienceId, selectedCreatives = [], onEdit, onCreativeRemove }) => {
        const handleRemoveClick = (creativeId) =>
            onCreativeRemove({ audienceId: audience.id, stageId: stage.id, creativeId })

        return (
            <div
                className="tw:border-l-4 tw:hover:bg-gray-500 tw:flex tw:items-center tw:justify-between tw:group tw:relative tw:min-h-[56px]"
                style={{ borderLeftColor: stage.color }}
            >
                {/* Left side: Radio button and audience info */}
                <Label className="tw:py-2 tw:px-5 tw:!flex tw:gap-3 tw:items-center tw:flex-1">
                    {/* Radio button */}
                    <RadioGroupItem value={stageAudienceId} className="tw:cursor-pointer" />

                    {/* Audience icon and name */}
                    <div className="tw:flex tw:items-center tw:gap-2">
                        {audience.icon && <AudienceIcon icon={audience.icon} size="sm" />}
                        <span className="tw:text-sm tw:text-white">{audience.name}</span>
                        <CountBadge stage={stage} count={selectedCreatives.length} />
                        {/* Campaign count next to audience name */}
                    </div>
                </Label>

                {/* Right side: Creative thumbnails preview */}
                <div className="tw:flex tw:items-start tw:pr-5 tw:py-2 tw:min-h-[56px]">
                    {/* Creative thumbnails preview */}
                    <div className="tw:flex tw:flex-wrap tw:gap-1 tw:max-w-[300px] tw:justify-end">
                        {selectedCreatives.map((creative, index) => (
                            <CreativeThumbnail
                                size={40}
                                creative={creative}
                                key={creative.id || index}
                                onRemove={() => handleRemoveClick(creative.id)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        )
    },
)

AudienceStageItem.displayName = 'AudienceStageItem'

export default AudienceStageItem
